import { encodeObject } from '@simonbackx/simple-encoding';
export class IPaginatedResponse {
    results;
    next;
}
export class UnencodeablePaginatedResponse {
    results;
    next;
    constructor(data) {
        this.results = data.results;
        this.next = data.next;
    }
}
export class PaginatedResponse {
    results;
    next;
    constructor(data) {
        this.results = data.results;
        this.next = data.next;
    }
    encode(context) {
        return {
            results: encodeObject(this.results, context), // this.results.map(r => r.encode(context)),
            next: this.next?.encode(context),
        };
    }
}
export class PaginatedResponseDecoder {
    resultDecoder;
    querydecoder;
    constructor(resultDecoder, querydecoder) {
        this.resultDecoder = resultDecoder;
        this.querydecoder = querydecoder;
    }
    decode(data) {
        return new PaginatedResponse({
            results: data.field('results').decode(this.resultDecoder),
            next: data.optionalField('next')?.decode(this.querydecoder),
        });
    }
}
//# sourceMappingURL=PaginatedResponse.js.map